import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import AwsConfig from '../../Config/AwsConfig'
import MovieImagePresignedUrl from '../../Services/Queries/Movieimagepresignedurl'

const RemoveButton = ({ onClick, disabled }) => (
  <button className='remove btn btn-danger' type='button' onClick={onClick} disabled={disabled}>
    X
  </button>
)

const PersonPoster = props => {
  const { sendposterurl, sendtruevalue, personPoster, disableInput } = props
  const [urlImage, setUrlImage] = useState('')
  const [requiredImageSize, setRequiredImageSize] = useState(true)

  const poster = event => {
    sendtruevalue('poster', true)
    setUrlImage(event.target.files[0])
    sendposterurl('personPoster', '')
  }

  const uploadSelectedImage = async () => {
    try {
      const maxSize = 1024 * 1024 // 1MB
      if (urlImage.size > maxSize) {
        setRequiredImageSize(false)
        return
      }

      setRequiredImageSize(true)

      const randomId = await uuidv4()
      const personPath = AwsConfig.personPathUrl
      const key = `${personPath}${randomId}.jpeg`

      const params = {
        key,
        mimeType: 'image/jpeg',
      }

      const preSignedURLObject = await getPreSignedURL(params)

      const { fields, url: signedURL } = preSignedURLObject.data

      const formData = new FormData()
      Object.entries(fields).forEach(([key, value]) => {
        formData.append(key, value)
      })
      formData.append('file', urlImage)

      await uploadToS3(signedURL, formData)

      const cdnurl = AwsConfig.movieCdnUrl
      const posterUrl = `${cdnurl}${key}`

      sendposterurl('personPoster', posterUrl)
    } catch (err) {
      console.warn(err, 'err')
      // Handle errors, provide user feedback, etc.
    }
  }

  const getPreSignedURL = async params => {
    const preSignedURLObject = await MovieImagePresignedUrl(params)
    return JSON.parse(preSignedURLObject.signedObject)
  }

  const uploadToS3 = async (signedURL, formData) => {
    await axios({
      method: 'post',
      url: signedURL,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  useEffect(() => {
    uploadSelectedImage()
  }, [urlImage])

  return (
    <div className='poster'>
      <div className='shotbio margintop'>
        <label>
          Poster:<span className='mandatory'>*</span>
        </label>
        <input
          className='form-control'
          type='file'
          id='image-upload'
          accept='image/*'
          disabled={disableInput === true}
          onChange={poster}
          style={{
            color: personPoster ? 'black' : 'transparent',
            width: '50%',
          }}
        />
        <div>
          <div style={{ position: 'relative', left: '165px', top: '36px' }}>
            {personPoster && (
              <RemoveButton
                onClick={() => sendposterurl('personPoster', '')}
                disabled={disableInput === true}
              />
            )}
          </div>
          {personPoster && (
            <>
              <img
                src={personPoster}
                className='posterimage'
                alt='poster-url'
                width='200'
                height='200'
              />
            </>
          )}
        </div>
      </div>
      {!personPoster && <span className='mandatory1'>poster url should not be empty </span>}
      {!requiredImageSize && (
        <span className='mandatory1'>ImageSize should not be more than 1mb </span>
      )}
    </div>
  )
}

export default PersonPoster
